import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { iniCreateBudget } from "../../../redux/actions/pptos";

// css
import "./crear.css";
import { Templates } from "../../pptos/templates/Templates";
import { CreateList } from "./CreateList";
import { ChevronDown, Plus } from "lucide-react";
import { ButtonsCreate } from "../../reusableUI/v2UI/ButtonsCreate";

export const Crear = ({
  from,
  openDialogModalImports = null,
  setOpenDialogModalImports = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openTemplates, setOpenTemplates] = useState(false);

  const createPpto = () => {
    dispatch(iniCreateBudget());
    navigate(`/ppto/0`);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const idx = open ? "simple-popover" : undefined;

  const handleCreate = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const createFrom = (from) => {
    if (from === "cero") {
      createPpto();
    } else {
      if (from === "excel") {
        setOpenDialogModalImports(true);
      } else {
        setOpenTemplates(true);
      }
    }
  };

  return (
    <>
      <ButtonsCreate
        icon={<Plus size={16} />}
        name="Nuevo Presupuesto"
        icon2={<ChevronDown size={16} />}
        handleClick={handleCreate}
      />

      <CreateList
        idx={idx}
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        createFrom={createFrom}
      />

      {openTemplates && (
        <Templates
          open={openTemplates}
          setOpen={setOpenTemplates}
          createFrom={createFrom}
        />
      )}
    </>
  );
};
